module.exports = __webpack_public_path__ + "img/outlook.c0a720d4.svg";